const auctionAccess = {
  state: {
    auctionAccessId: -1,
    last4PhotoId: -1,
    organizations: [],
    firstName: null,
    lastName: null,
    recaptchaVal: null,
    dealerEmail: null,
    preferredLanguage: null,
    googleConversionInfo: {
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      utmTerm: null,
      googleClickId: null,
    },
    dealerIssues: [],
  },
  mutations: {
    setAAId(state, value) {
      state.auctionAccessId = value;
    },
    setPhotoId(state, value) {
      state.last4PhotoId = value;
    },
    setRecaptchaVal(state, value) {
      state.recaptchaVal = value;
    },
    setDealerEmail(state, value) {
      state.dealerEmail = value;
    },
    setAAInfo(state, value) {
      const {
        firstName,
        lastName,
        organizations,
        preferredLanguage,
        email,
      } = value;
      state.firstName = firstName;
      state.lastName = lastName;
      state.organizations = organizations;
      state.preferredLanguage = preferredLanguage;
      state.dealerEmail = email;
    },
    setGoogleConversionInfo(state, value) {
      state.googleConversionInfo = { ...value };
    },
    setAuctionAccessDealerIssues(state, value) {
      state.dealerIssues = value;
    },
    clearAllAAData(state) {
      state.auctionAccessId = -1;
      state.last4PhotoId = -1;
      state.organizations = [];
      state.firstName = null;
      state.lastName = null;
      state.recaptchaVal = null;
      state.dealerEmail = null;
      state.preferredLanguage = null;
    },
    clearGoogleConversionInfo(state) {
      state.googleConversionInfo = {
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmTerm: null,
        googleClickId: null,
      };
    },
  },
  actions: {
    clearAllAAData({ commit }) {
      commit('clearAllAAData');
    },
    clearGoogleConversionInfo({ commit }) {
      commit('clearGoogleConversionInfo');
    },
    updateAAId({ commit }, value) {
      commit('setAAId', value);
    },
    updatePhotoId({ commit }, value) {
      commit('setPhotoId', value);
    },
    updateAAInfo({ commit }, value) {
      commit('setAAInfo', value);
    },
    updateGoogleConversionInfo({ commit }, value) {
      commit('setGoogleConversionInfo', value);
    },
    updateRecaptchaVal({ commit }, value) {
      commit('setRecaptchaVal', value);
    },
    updateAuctionAccessDealerIssues({ commit }, value) {
      commit('setAuctionAccessDealerIssues', value);
    },
  },
  getters: {
    auctionAccessId: (state) => state.auctionAccessId,
    last4PhotoId: (state) => state.last4PhotoId,
    aaOrganizations: (state) => state.organizations,
    aaFirstName: (state) => state.firstName,
    aaLastName: (state) => state.lastName,
    dealerEmail: (state) => state.dealerEmail,
    preferredLanguage: (state) => state.preferredLanguage,
    recaptchaVal: (state) => state.recaptchaVal,
    googleConversionInfo: (state) => state.googleConversionInfo,
    aaDealerIssues: (state) => state.dealerIssues,
  },
};

export const {
  mutations, actions, state, getters,
} = auctionAccess;

export default auctionAccess;
